export default function SelectStoreRestrictPopup() {
	var modalShown = 0;
	const modal = document.querySelector(".theme-redirect-modal");
	let isModalOpen = false;
	const overLay = document.querySelector(".theme-redirect-modal__overlay");
	const body = document.querySelector("body");
	const html = document.querySelector("html");

	function setCookie(name, value, daysToLive, domain) {
		var cookie = name + "=" + encodeURIComponent(value);

		if (typeof daysToLive === "number") {
			cookie += "; max-age=" + daysToLive * 24 * 60 * 60 + ";domain=" + domain;
			document.cookie = cookie;
		}
	}

	function getCookie(name) {
		var cookieArr = document.cookie.split(";");
		for (var i = 0; i < cookieArr.length; i++) {
			var cookiePair = cookieArr[i].split("=");

			if (name == cookiePair[0].trim()) {
				return decodeURIComponent(cookiePair[1]);
			}
		}
		return null;
	}

	window.onload = function () {
		if (modal.classList.contains("theme-redirect-modal--active")) {
			if (document.cookie.indexOf("modalShown") == -1) {
				modalShown++;
			} else {
				modalShown = getCookie("modalShown");
				modalShown++;
			}
			setCookie("modalShown", modalShown, 10, ".choosemuse.com");

			if (getCookie("modalShown") > 2) {
				modal.classList.remove("theme-redirect-modal--active");
				overLay.classList.remove("theme-redirect-modal__overlay--active");
				body.classList.remove("modal--active");
				html.classList.remove("modal--active");
				isModalOpen = false;
			}
		}

		var oldSrc = document
			.querySelector(".navigation__actions")
			.querySelector(".theme-button")
			.getAttribute("href");
		if (document.querySelector(".global-hero__button") != null) {
			var oldSrcHeroBtn = document
				.querySelector(".global-hero__button")
				.querySelector(".theme-button")
				.getAttribute("href");
		}

		var euCountryList = [
			"AT",
			"BE",
			"HR",
			"CZ",
			"DK",
			"EE",
			"FI",
			"FR",
			"DE",
			"HU",
			"IE",
			"IT",
			"LV",
			"LT",
			"LU",
			"NL",
			"PL",
			"PT",
			"RO",
			"SK",
			"SI",
			"ES",
			"SE",
			"GB",
		];
		var CPVisitorCountry = localStorage.getItem("CPVisitorCountry");
		var ip_country = localStorage.getItem("ip_country");
		var userCountry = CPVisitorCountry !== "" ? CPVisitorCountry : ip_country;

		if (euCountryList.indexOf(userCountry) !== -1) {
			document
				.querySelector(".navigation__actions")
				.querySelector(".theme-button")
				.setAttribute(
					"href",
					oldSrc.replace("/pages/", "https://eu.choosemuse.com/pages/")
				);
			if (document.querySelector(".global-hero__button") != null) {
				document
					.querySelector(".global-hero__button")
					.querySelector(".theme-button")
					.setAttribute(
						"href",
						oldSrcHeroBtn.replace(
							"/products/",
							"https://eu.choosemuse.com/products/"
						)
					);
			}

			if (getCookie("modalShown") > 2) {
				localStorage.setItem("muse_location", "eu");
			}
		} else if (userCountry == "US") {
			document
				.querySelector(".navigation__actions")
				.querySelector(".theme-button")
				.setAttribute(
					"href",
					oldSrc.replace("/pages/", "https://choosemuse.com/pages/")
				);
			if (document.querySelector(".global-hero__button") != null) {
				document
					.querySelector(".global-hero__button")
					.querySelector(".theme-button")
					.setAttribute(
						"href",
						oldSrcHeroBtn.replace(
							"/products/",
							"https://choosemuse.com/products/"
						)
					);
			}
			if (getCookie("modalShown") > 2) {
				localStorage.setItem("muse_location", "us");
			}
		} else if (userCountry == "CA") {
			document
				.querySelector(".navigation__actions")
				.querySelector(".theme-button")
				.setAttribute(
					"href",
					oldSrc.replace("/pages/", "https://ca.choosemuse.com/pages/")
				);
			if (document.querySelector(".global-hero__button") != null) {
				document
					.querySelector(".global-hero__button")
					.querySelector(".theme-button")
					.setAttribute(
						"href",
						oldSrcHeroBtn.replace(
							"/products/",
							"https://ca.choosemuse.com/products/"
						)
					);
			}
			if (getCookie("modalShown") > 2) {
				localStorage.setItem("muse_location", "ca");
			}
		} else {
			document
				.querySelector(".navigation__actions")
				.querySelector(".theme-button")
				.setAttribute(
					"href",
					oldSrc.replace("/pages/", "https://intl.choosemuse.com/pages/")
				);
			if (document.querySelector(".global-hero__button") != null) {
				document
					.querySelector(".global-hero__button")
					.querySelector(".theme-button")
					.setAttribute(
						"href",
						oldSrcHeroBtn.replace(
							"/products/",
							"https://intl.choosemuse.com/products/"
						)
					);
			}
			if (getCookie("modalShown") > 2) {
				localStorage.setItem("muse_location", "intl");
			}
		}
	};
}
